import { CompanyAdminMeta } from '@dispatch/shared/types';
import { GridRowParams } from '@mui/x-data-grid';

export const handleModalOpen = (
  key: string,
  modalState?: {
    meta: CompanyAdminMeta;
    setmeta: React.Dispatch<CompanyAdminMeta>;
  }
) => {
  const openState = modalState?.meta;
  if (openState) {
    openState[key as keyof typeof openState].open = true;
    modalState?.setmeta?.({ ...openState });
  }
};

export const onClick = (
  key: string,
  params: GridRowParams & { type?: string },
  modalState?: {
    meta: CompanyAdminMeta;
    setmeta: React.Dispatch<CompanyAdminMeta>;
  }
) => {
  const openState = modalState?.meta;
  const meta: { open: boolean; data: unknown } | undefined =
    openState?.[key as keyof typeof openState];

  if (openState && meta?.['open']) {
    meta.open = true;
    meta.data = params.row;
    modalState.setmeta?.({ ...openState });
  } else {
    if (openState) {
      openState[key as keyof typeof openState] = {
        open: true,
        data: { ...params.row, type: params.type },
      };
      modalState.setmeta?.({ ...openState });
    }
  }
};

export const onCancel = (
  key: string,
  modal: CompanyAdminMeta,
  setModal: React.Dispatch<CompanyAdminMeta>
) => {
  const state = modal;

  if (key) {
    state[key as keyof typeof modal].open = false;
    state[key as keyof typeof modal].data = null;
    setModal({ ...state });
  }
};
